import type { PolicyBlock } from '../types/domain.types';

const root = ['close-the-loop'] as const;

export const ctlKeys = {
  all: root,
  settings: {
    me: () => [...root, 'settings', 'me'] as const,
  },
  feed: {
    me: () => [...root, 'feed', 'me'] as const,
  },
  landing: (token: string) => [...root, 'landing', token] as const,
  policyAll: () => [...root, 'policy'] as const,
  policy: (plantId: string) => [...root, 'policy', plantId] as const,
  routingAll: () => [...root, 'routing'] as const,
  routing: (plantId: string) => [...root, 'routing', plantId] as const,
  plantProfile: (plantId: string) => [...root, 'plant-profile', plantId] as const,
  pushDevice: () => [...root, 'push', 'this-device'] as const,
} as const;

const mutationRoot = [...root, 'mut'] as const;

export const ctlMutationKeys = {
  settings: () => [...mutationRoot, 'settings'] as const,
  onboarding: () => [...mutationRoot, 'onboarding'] as const,
  startIssue: (issueId: string) => [...mutationRoot, 'start-issue', issueId] as const,
  landingStart: (token: string) => [...mutationRoot, 'landing', token, 'start'] as const,
  landingTakeOver: (token: string) => [...mutationRoot, 'landing', token, 'take-over'] as const,
  pushSubscribe: () => [...mutationRoot, 'push', 'subscribe'] as const,
  pushUnsubscribe: () => [...mutationRoot, 'push', 'unsubscribe'] as const,
  pushSync: () => [...mutationRoot, 'push', 'sync'] as const,
  policy: (plantId: string, block?: PolicyBlock) =>
    block === undefined ? ([...mutationRoot, 'policy', plantId] as const) : ([...mutationRoot, 'policy', plantId, block] as const),
  personChannel: (plantId: string, userId: string) => [...mutationRoot, 'person-channel', plantId, userId] as const,
  plantProfile: (plantId: string) => [...mutationRoot, 'plant-profile', plantId] as const,
} as const;

export const ctlMutationScopes = {
  settingsMe: { id: 'ctl-settings-me' },
  pushDevice: { id: 'ctl-push-device' },
} as const;

export const CTL_STALE = {
  settings: 30 * 1000,
  feed: 15 * 1000,
  landing: 15 * 1000,
  policy: 30 * 1000,
  routing: 30 * 1000,
  plantProfile: 5 * 60 * 1000,
} as const;

export const CTL_GC = 10 * 60 * 1000;
